export const OT_V3_ORDER = 'OT_V3_ORDER'
export const OT_RETURN_ORDER = 'OT_RETURN_ORDER'
export const OT_NONE = 'OT_NONE'
